export const vipCustomersMessages = {
  create: 'Tạo mới khách hàng VIP',
  update: 'Cập nhật khách hàng VIP',
  code: 'Mã khách hàng VIP',
  name: 'Tên khách hàng VIP',
  note: 'Ghi chú',
  color: 'Màu sắc đại diện',
  phoneNumber: 'Số điện thoại',
  delete: 'Xóa khách hàng VIP',
  confirmDelete: 'Bạn có chắc chắn muốn xóa khách hàng VIP này không?',
  vipCustomer: 'Khách hàng VIP',
  vipCustomerGroup: 'Nhóm khách hàng',
  groupName: 'Tên nhóm',
  participant: 'Thành viên',
  createGroup: 'Tạo mới nhóm khách hàng ',
  updateGroup: 'Cập nhật nhóm khách hàng '
};
